import React from 'react';
import { ButtonProps as ReactstrapButtonProps } from 'reactstrap';
import { useIntl } from 'react-intl';
import { ReactComponent as IconLoading } from '@whitelabel/media/icons/loading.svg';
import { bwClickTracking } from '@whitelabel/helpers/analytics';
import { ButtonType } from '@whitelabel/helpers/types';
import { StyledButton, StyledIcon } from './styled';

export type IButtonProps = {
  buttonType?: ButtonType;
  /**
   * icon can be any svgIcon
   */
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | string;
  iconPosition?: 'left' | 'right' | 'top';
  block?: boolean;
  size?: 'xs' | 'sm' | 'md';
  active?: boolean;
  tag?: React.ElementType;
  loading?: boolean;
  disabled?: boolean;
  onClick?: (...args: any[]) => void;
  'aria-label'?: string;
  children?: React.ReactNode;
} & ReactstrapButtonProps;

const Button = ({
  loading,
  disabled,
  icon: Icon,
  iconPosition = 'left',
  children,
  size = 'md',
  buttonType = 'primary',
  block = false,
  onClick,
  tag = 'button',
  ...props
}: IButtonProps): JSX.Element => {
  const intl = useIntl();
  const handleButtonClick = (e: Event) => {
    bwClickTracking(e);
    if (onClick) {
      onClick(e);
    }
  };
  return (
    <StyledButton
      $rtl={intl.bidi}
      disabled={disabled || loading}
      buttonType={buttonType}
      onClick={handleButtonClick}
      $block={block}
      size={size}
      tag={tag}
      $icon={Icon}
      $iconPosition={iconPosition}
      {...props}
    >
      {loading ? (
        <IconLoading title="Loading" />
      ) : (
        <>
          {Icon && <StyledIcon size={size} $rtl={intl.bidi} as={Icon} $iconPosition={iconPosition} />}
          {children}
        </>
      )}
    </StyledButton>
  );
};

export default Button;
